import { rem } from "polished";

/**
 * Returns values converted to rem units from provided values in pixels
 *
 * @param values - Values provided in pixels
 * @returns Values converted to rem units
 */

function unit() {
  var result = [];
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  values.forEach(function (value) {
    return result.push(rem(value));
  });
  if (result.length > 1) {
    return result;
  }
  return result[0];
}
export default unit;